// extracted by mini-css-extract-plugin
export var container = "_rm-0";
export var dotAnimation = "_rm-2";
export var dotsLoading = "_rm-1";